// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"top-menu-module--menu-item--1sF59"};